import { prettyPrintCondition, prettyPrintDateCondition } from '@/Utils/filterConditions';
import { getFilterConditions } from '@/helpers/filterPanelHelper';

export const generateOperatorsOptions = (colId, fieldType) => {
  return getFilterConditions(colId, fieldType).map((el) => ({
    value: el,
    label:
      fieldType === 'DateTime' || fieldType === 'DateTime64'
        ? prettyPrintDateCondition(el)
        : prettyPrintCondition(el),
  }));
};
